<template>
    <article class="container-fluid">
        <div class="row primary-text">
            <div :class="featured ? 'col-md-4' : 'col-md-12'" class="col-12 mt-3">
                <a :href="href"><h2 class="fs-h2 font-family-alternative text-uppercase" v-html="title"></h2></a>
            </div>
            <div :class="featured ? 'col-md-7 offset-md-1' : 'col-md-12'" class="col-12 mt-3">
                <a :href="href">
                    <p v-html="description" class="mb-4 fs-smalltext aicon-arrow"></p>
                </a>
            </div>
        </div>
    </article>
</template>

<script>
    export default {
        props: {
            article: {
                type: Object,
                required: true,
            }
        },
        computed: {
            featured () {
                return this.article.featured;
            },
            title () {
                return this.article.title;
            },
            description () {
                return this.article.description;
            },
            href () {
                return this.article.href;
            },
            styles () {
                return {
                    paddingTop: this.padding,
                }
            }
        }
    }
</script>
